
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ios-app-development-services",
      function () {
        return require("private-next-pages/ios-app-development-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ios-app-development-services"])
      });
    }
  